import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

import Localization from "composer/Localization.jsx"
import RetrieverPage from "composer/pages/RetrieverPage.jsx"

import {
  Icon,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import {
  grey,
} from '@material-ui/core/colors'

const styles = {
  localeFilter: {
    display:'inline-block',
    verticalAlign:'middle',
    padding: '0 10px',
  },
};

class RetrieverBar extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      hasRouteData: false,
      submissionList: [],
      userOption: 0,
    };
    autoBind(this);
  }

  componentDidMount(){
    console.log('RetrieverBar rendered');
    console.log('in retrieverBar bounding rect: ', this.refs.div.getBoundingClientRect());
  }

  onBackClicked() {
    console.log('onbackclicked');
    this.setState({ hasRouteData: false });
    this.props.root.goBackHistory();
  }

  userOptionChanged(e) {
    console.log(e);
    this.setState({ userOption: e.target.value });

    this.props.parent.refreshSubmissionDetail(e.target.value);
  }

  render() {
    return (
      <div ref="div" style={{padding:"10px 0 10px 10px", backgroundColor:grey[300]}}>
        <Switch condition={this.props.parent.state.status}>
          <Case value={RetrieverPage.RET_VIEW_DATES()}>
            <Button
              color="secondary"
              onClick={this.onBackClicked}
            >
              <Icon className="buttonIconLeft">arrow_back</Icon>
              {Localization.strings.BACK}
            </Button>
          </Case>
          <Case value={RetrieverPage.RET_VIEW_SUBMISSION_GROUPS()}>
            <Button
              color="secondary"
              onClick={this.onBackClicked}
            >
              <Icon className="buttonIconLeft">arrow_back</Icon>
              {Localization.strings.SUBMISSION_DATE}
            </Button>
            <div style={styles.localeFilter}>
              <FormControl disabled={this.state.submissionList.length <= 1}>
                <InputLabel>{Localization.strings.SUBMISSION_TIME}</InputLabel>
                <Select
                  value={this.state.userOption}
                  onChange={this.userOptionChanged} 
                  displayEmpty={true}
                >
                  {this.state.submissionList.map( (row, i) => {
                    return (
                      <MenuItem key={i} value={row['id']}>{row['submission_time'].substring(row['submission_time'].indexOf(' '))}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <Tooltip title={Localization.strings.ARCHIVE} disabled={this.state.submissionList.length == 0}>
              <IconButton onClick={()=>this.props.parent.download_ans(this.props.parent.props.localeData['name'] + '_' + this.props.parent.state.currentUsername + '_' + this.state.userOption + '.xlsx', this.state.userOption)}>
              {/* <IconButton onClick={()=>console.log(this.props.parent.props.localeData['name'], this.props.parent.state.currentUsername, this.state.userOption)}> */}
                <Icon>archive</Icon>
              </IconButton>
            </Tooltip>
            <Tooltip title={Localization.strings.SHARE} disabled={this.state.submissionList.length == 0}>
              <IconButton>
                <Icon>share</Icon>
              </IconButton>
            </Tooltip>
            <Button
              color="primary"
              onClick={this.props.parent.handleRouteClicked}
              disabled={!this.state.hasRouteData}
            >
              <Icon className="buttonIconLeft">map</Icon>
              User Route
            </Button>
          </Case>
        </Switch>
      </div>
    )
  }
}

export default RetrieverBar;
